module.exports = __webpack_public_path__ + "static/media/grandValleyFloorPlan1.95d36b9f.png";